import type {DocumentPartsResponse} from "../types";
import {renderNode} from "./renderNodeLegacy";
import articleClasses from "../legacy/HtmlArticleLEGACY.module.css";
import panelClasses from "../panel/panelContent.module.css";

export const PanelDocumentPartsLEGACY = ({
    data,
}: {
    data: DocumentPartsResponse;
}) => {
    return (
        <div className={articleClasses.content} data-pw="panel-content">
            {data.parts.map((part, index) => (
                <div className={panelClasses.part} key={`part-${index}`}>
                    {renderNode(
                        part,
                        part.root[0].id,
                        {skipAugmentations: true},
                        `part-${index}`
                    )}
                </div>
            ))}
        </div>
    );
};
